/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'

import {
  Modal,
  TextArea,
  Button
} from '../'

export class RequestInvalidateModal extends React.Component {
  static propTypes = {
    forwardedRef: PropTypes.object,
    requestRun: PropTypes.object,
    requestrunMutate: PropTypes.func,
    closeModal: PropTypes.func
  }

  state = {
    notes: this.props.requestRun.notes
  }

  handleSaveNotesClick = () => {
    if (this.state.notes !== this.props.requestRun.notes) {
      this.props.requestrunMutate({
        variables: {
          input: {
            id: this.props.requestRun.id,
            notes: this.state.notes
          }
        }
      })
      .then(() => this.props.closeModal())
      .catch(error => Sentry.captureMessage(`Failed to update request run notes - ${error}`))
    } else {
      this.props.closeModal()
    }
  }

  render() {
    const { forwardedRef, closeModal, requestRun } = this.props

    return (
      <Modal
        ref={forwardedRef}
        body={
          <div className='slds-text-align_center'>
            <TextArea
              label='Please add a note'
              value={this.state.notes}
              onChange={e => this.setState({ notes: e.target.value })}
              rows={5}
            />
            <div className='slds-m-top_medium'>
              <Button
                id='requestInvalidateCancel'
                minWidth={140}
                onClick={() => this.setState({ notes: requestRun.notes }, closeModal)}>
                Cancel
              </Button>
              <Button
                id='requestInvalidateConfirm'
                type='brand'
                minWidth={140}
                onClick={() => this.handleSaveNotesClick()}>
                Invalidate
              </Button>
            </div>
          </div>
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-invalidate-modal/index.js